import { axios } from '../../../../axios';

const addRenterApi = (data) => {
  return axios.post('/users/renters', data)
}
const updateRenterApi = (data) => {
  return axios.put(`/users/renters`, data)
}

const getRenterApi = () => {
  return axios.get(`/users/renters`)
}

const deleteRenter = () => {
  return axios.delete(`/users/renters/`)
}

export { addRenterApi, updateRenterApi, getRenterApi, deleteRenter }